import inventoryCatalog from "../../data/inventoryCatalog.json";
import type { InventoryCatalogCategorySchema, InventoryCatalogSuggestion } from "../../data/types";

export const INVENTORY_CATALOG_SUGGESTION_LIMIT = 3;

const slugifyName = (name: string): string => name.toLowerCase().replace(/\s+/g, "-");

const buildCategoryIndex = (
  catalog: InventoryCatalogCategorySchema[]
): Map<string, readonly InventoryCatalogSuggestion[]> => {
  const index = new Map<string, readonly InventoryCatalogSuggestion[]>();

  for (const entry of catalog) {
    if (!entry.items?.length) continue;

    const suggestions: InventoryCatalogSuggestion[] = entry.items.map((item) => ({
      ...item,
      id: `${entry.category}-${slugifyName(item.name)}`,
      category: entry.category,
    }));

    index.set(entry.category.toLowerCase(), suggestions);
  }

  return index;
};

const CATEGORY_INDEX = buildCategoryIndex(inventoryCatalog as InventoryCatalogCategorySchema[]);

export const searchInventoryCatalog = (
  category: string,
  query: string,
  limit = INVENTORY_CATALOG_SUGGESTION_LIMIT
): InventoryCatalogSuggestion[] => {
  const normalizedCategory = category.trim().toLowerCase();
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedCategory || !normalizedQuery || limit <= 0) {
    return [];
  }

  const items = CATEGORY_INDEX.get(normalizedCategory);
  if (!items?.length) {
    return [];
  }

  const results: InventoryCatalogSuggestion[] = [];

  for (const item of items) {
    if (item.name.toLowerCase().includes(normalizedQuery)) {
      results.push(item);
      if (results.length >= limit) {
        break;
      }
    }
  }

  return results;
};
